import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45efa84c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "getStarted table m-auto max-w-lg text-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Connect a wallet to get started", -1))
const _hoisted_3 = {
  key: 1,
  class: "wrapper"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "mb-10" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full justify-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "images/FE-NFT.gif",
    width: "125",
    class: "animated-logo",
    alt: ""
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center mb-5" }, " You need a staking account to get started. ", -1))
const _hoisted_9 = { class: "w-full text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_FarmerDisplay = _resolveComponent("FarmerDisplay")!
  const _component_Vault = _resolveComponent("Vault")!

  return (!_ctx.wallet)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_ConfigPane)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        (_ctx.farmerAcc)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(), _createBlock(_component_FarmerDisplay, {
                key: _ctx.farmerAcc,
                farm: _ctx.farm,
                farmAcc: _ctx.farmAcc,
                farmer: _ctx.farmer,
                farmerAcc: _ctx.farmerAcc,
                availableA: _ctx.availableA,
                onClaim: _ctx.claim,
                class: "mb-10"
              }, null, 8, ["farm", "farmAcc", "farmer", "farmerAcc", "availableA", "onClaim"])),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createBlock(_component_Vault, {
                  ref: "vaultComponent",
                  key: _ctx.farmerAcc,
                  vault: _ctx.farmerAcc.vault.toBase58(),
                  farmerState: _ctx.farmerState,
                  onSelectedWalletNft: _ctx.handleSelectedWalletNFT,
                  onCurrentWalletNft: _ctx.handleCurrentWalletNFT,
                  onSelectedVaultNft: _ctx.handleSelectedVaultNFT,
                  onCurrentVaultNft: _ctx.handleCurrentVaultNFT,
                  onVaultBeginStaking: _ctx.handleVaultBeginStaking,
                  onVaultFullEndStaking: _ctx.fullEndStaking,
                  onVaultStakedAddNft: _ctx.addGems,
                  onRefreshAccount: _ctx.fetchFarmer
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "btnSite nes-btn is-warning",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshFarmer && _ctx.refreshFarmer(...args)))
                    }, " Refresh ")
                  ]),
                  _: 1
                }, 8, ["vault", "farmerState", "onSelectedWalletNft", "onCurrentWalletNft", "onSelectedVaultNft", "onCurrentVaultNft", "onVaultBeginStaking", "onVaultFullEndStaking", "onVaultStakedAddNft", "onRefreshAccount"]))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btnSite nes-btn is-primary",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                }, " New Account ")
              ])
            ]))
      ]))
}